import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import SalesPersonTasksService from "../utils/SalesPersonTasksService";

// Predefined task types
const TASK_TYPES = [
  { label: 'One off', value: 'one_off' },
  { label: 'Recurring - Daily', value: 'recurring_daily' },
  { label: 'Recurring - Weekly', value: 'recurring_weekly' },
  { label: 'Incomplete Sale', value: 'incomplete_sale' },
  { label: 'Client Follow-up', value: 'client_follow_up' }
];

class TaskFormModal extends Component {
  constructor(props) {
    super(props);
    
    const task = props.task || {};
    this.state = {
      title: task.title || "",
      due_date: task.due_date || "",
      assignee_id: task.assignee_id || "",
      deal_id: task.deal_id || "",
      type: task.type || "",
      availableTypes: [],
      loadingOptions: true
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // Fetch available types from backend
    SalesPersonTasksService.getOptions()
      .then(data => {
        // Filter out "Sales Overdue" - it's a system-managed type
        const types = (data.types || []).filter(type => type !== 'Sales Overdue');
        this.setState({
          availableTypes: types,
          loadingOptions: false
        });
      })
      .catch(error => {
        console.error("Failed to load options:", error);
        this.setState({ loadingOptions: false });
      });
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    
    const taskData = {
      title: this.state.title,
      due_date: this.state.due_date || null,
      assignee_id: this.state.assignee_id || null,
      deal_id: this.state.deal_id || null,
      type: this.state.type || null
    };

    this.props.onSave(taskData);
  }

  render() {
    const { onClose, isAdmin, users } = this.props;
    const isEditing = !!this.props.task;

    const titleCase = str => {
      if (!str) return str;
      return str.replace(/_/g, " ").replace(/\w\S*/g, txt => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    };

    return (
      <Modal show={true} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? "Edit Task" : "Create New Task"}</Modal.Title>
        </Modal.Header>
        <form onSubmit={this.handleSubmit}>
          <Modal.Body>
            <div className="form-group">
              <label htmlFor="title">Title *</label>
              <input
                type="text"
                name="title"
                id="title"
                className="form-control"
                value={this.state.title}
                onChange={this.handleChange}
                required
                placeholder="Enter task title"
              />
            </div>

            <div className="form-group">
              <label htmlFor="due_date">Due Date</label>
              <input
                type="date"
                name="due_date"
                id="due_date"
                className="form-control"
                value={this.state.due_date}
                onChange={this.handleChange}
              />
            </div>

            {isAdmin && (
              <div className="form-group">
                <label htmlFor="assignee_id">Assignee</label>
                <select
                  name="assignee_id"
                  id="assignee_id"
                  className="form-control"
                  value={this.state.assignee_id}
                  onChange={this.handleChange}
                >
                  <option value="">Select assignee...</option>
                  {users
                    .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                    .map(user => (
                      <option key={user.id} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                </select>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="type">Type</label>
              <select
                name="type"
                id="type"
                className="form-control"
                value={this.state.type}
                onChange={this.handleChange}
              >
                <option value="">Select type...</option>
                {this.state.availableTypes.map(type => (
                  <option key={type} value={type}>
                    {titleCase(type)}
                  </option>
                ))}
              </select>
              {this.state.availableTypes.length === 0 && !this.state.loadingOptions && (
                <small className="text-muted">
                  No types available. Admin can create types in "Manage Types".
                </small>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="deal_id">Deal ID (optional)</label>
              <input
                type="number"
                name="deal_id"
                id="deal_id"
                className="form-control"
                value={this.state.deal_id}
                onChange={this.handleChange}
                placeholder="Enter deal ID if related to a deal"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" type="submit">
              {isEditing ? "Update" : "Create"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

export default TaskFormModal;
